import * as yup from "yup";

const EducationValidator = yup.object({
  status: yup.string().required("Statusu is required"),

  place_of_study: yup.string().when(["status"], {
    is: (status) => status === "undergraduate" || status === "graduate",
    then: yup.string().required("Place of study is required"),
  }),

  year_of_graduation: yup.string().when(["status"], {
    is: (status) => status === "graduate" || status === "undergraduate",
    then: yup.string().required('Year of graduation is required'),
  }),


  nysc_status: yup.string().when(["status"], {
    is: (status) => status === "graduate",
    then: yup.string().required('NYSC status is required'),
  }),

  year_of_pop: yup.string().when(["nysc_status", "status"], {
    is: (nysc_status, status) =>
      nysc_status === "currently-serving" && status === "graduate",
    then: yup.string().required('Year of pop is required'),
  }),

  services_location: yup.string().when(["nysc_status", "status"], {
    is: (nysc_status, status) =>
      nysc_status === "currently-serving" && status === "graduate",
    then: yup.string().required('NYSC location is required'),
  }),

  possible_date_of_mobilization: yup.string().when(["nysc_status", "status"], {
    is: (nysc_status, status) =>
      nysc_status === "currently-serving" && status === "graduate",
    then: yup.string().required('Mobilization date is required'),
  }),
});

export { EducationValidator };
